export { CordovaModule } from './cordova.module';
export { CordovaService } from './services';
export * from './types';
